const cancelPaymentLinkParser = (resp: any) => {
  return resp
}
export { cancelPaymentLinkParser }
